export class EntFertilizerUsageFilter {
  page: number = 1;
  size: number = 30;
  territorialUnitIds: number[] | null = null;
  cropTypeIds: number[] | null = null;
  periodStart: string | null = null;
  periodEnd: string | null = null;
  minCropArea: number | null = null;
  maxCropArea: number | null = null;
  minFertilizerArea: number | null = null;
  maxFertilizerArea: number | null = null;
  createdFrom: number | null = null;
  createdTo: number | null = null;
  deleted: boolean = false;
}